const cartSVG = `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6.29977 5H21L19 12H7.37671M20 16H8L6 3H3M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20ZM20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`

if (!customElements.get('filter-by-model')) {
  customElements.define(
    'filter-by-model',
    class FilterByModel extends HTMLElement {
      constructor() {
        super()
        const params = new URLSearchParams(window.location.search)
        this.motoData = {}
        this.currentBrand = params.get('brand') ?? null
        this.currentModel = params.get('model') ?? null
        this.currentYearFrom = params.get('yearFrom') ?? null
        this.currentYearTo = params.get('yearTo') ?? null
        this.currentVendors = params.get('vendors')
          ? params.get('vendors').split(',')
          : []
        this.perPageLimit = 16
        this.currentPage = params.get('page') ?? 1
        this.brandsInited = false
        this.modelsInited = false
        this.yearFromInited = false
        this.yearToInited = false
        this.priceSuffix = this.dataset.priceSuffix
        this.brandsWithLogos = window.elsBrandsLogos ?? {}
        this.currentBrands = []
        this.matches = {}
        this.discountPercent = window.elsFilterDiscount ?? 5
      }

      connectedCallback() {
        this.brandsDropdown = this.querySelector('[filter-by-brand]')
        this.modelsDropdown = this.querySelector('[filter-by-model]')
        this.yearFromDropdown = this.querySelector('[filter-by-year-from]')
        this.yearToDropdown = this.querySelector('[filter-by-year-to]')
        this.submitBtn = this.querySelector('[data-filter-submit-btn]')
        this.notFoundEl = document.querySelector(
          '[data-filter-by-product-not-found]',
        )
        this.pagination = document.querySelector(
          '[data-filter-by-product-pagination]',
        )
        this.drawerTriggerBtn = document.querySelector(
          '[data-vendors-drawer-trigger]',
        )
        this.vendorListWrapper = document.querySelector('#FacetFiltersForm')
        this.vendorOptionsListEl = document.querySelector(
          '[data-vendor-options-list]',
        )
        this.submitFilterBtn = document.querySelector(
          '[data-submit-filter-btn]',
        )
        this.dismisssFilterBtn = document.querySelector(
          '[data-dismiss-filter-btn]',
        )

        this.resultsContainer = document.querySelector(
          '[data-filter-by-product-results]',
        )
        this.submitBtn.addEventListener(
          'click',
          this.onSumbitListener.bind(this),
        )
        this.submitFilterBtn.addEventListener(
          'click',
          this.onVendorsFilterAddBtn.bind(this),
        )
        this.dismisssFilterBtn.addEventListener(
          'click',
          this.onVendorsDismissBtn.bind(this),
        )
        this.brandsDropdown.addEventListener(
          'change',
          this.onDrodownChangeListener.bind(this),
        )
        this.modelsDropdown.addEventListener(
          'change',
          this.onDrodownChangeListener.bind(this),
        )
        this.yearFromDropdown.addEventListener(
          'change',
          this.onDrodownChangeListener.bind(this),
        )
        this.yearToDropdown.addEventListener(
          'change',
          this.onDrodownChangeListener.bind(this),
        )
        this.initialize()
      }

      async initialize() {
        try {
          await this.setCurrentMotoData()
          this.fillDropdownWithOptions(
            this.brandsDropdown,
            'brands',
            this.currentBrand,
          )
          this.brandsInited = true

          if (this.motoData['brands']?.length) {
            await this.setCurrentMotoData()
            this.fillDropdownWithOptions(
              this.modelsDropdown,
              'models',
              this.currentModel,
            )
          }
          this.modelsInited = true

          if (this.motoData['models']?.length) {
            await this.setCurrentMotoData()
            this.fillDropdownWithOptions(
              this.yearFromDropdown,
              'yearsFrom',
              this.currentYearFrom,
            )
          }
          this.yearFromInited = true

          if (this.motoData['yearsFrom']?.length) {
            await this.setCurrentMotoData()
            this.fillDropdownWithOptions(
              this.yearToDropdown,
              'yearsTo',
              this.currentYearTo,
            )
          }
          this.yearToInited = true

          this.currentBrand && this.getProducts()
        } catch (e) {
          console.log(e, 'error')
        }

        this.submitBtn.disabled = !this.currentModel
      }

      async setCurrentMotoData() {
        await this.getMotoData()
      }

      buildMotoDataUrl(baseUrl) {
        const params = new URLSearchParams()

        const currentBrand = this.currentBrand
        const currentModel = this.currentModel
        const currentYearFrom = this.currentYearFrom
        const currentYearTo = this.currentYearTo

        if (currentBrand && this.brandsInited)
          params.append('brand', currentBrand)
        if (currentModel && this.modelsInited)
          params.append('model', currentModel)
        if (currentYearFrom && this.yearFromInited)
          params.append('yearFrom', currentYearFrom)
        if (currentYearTo && this.yearToInited)
          params.append('yearTo', currentYearTo)

        return `${baseUrl}?${params.toString()}`
      }

      buildProductsUrl(baseUrl, options = {}) {
        const params = new URLSearchParams()

        const currentBrand = this.currentBrand
        const currentModel = this.currentModel
        const currentYearFrom = this.currentYearFrom
        const currentYearTo = this.currentYearTo

        if (currentBrand) params.append('brand', currentBrand)
        if (currentModel) params.append('model', currentModel)
        if (currentYearFrom) params.append('yearFrom', currentYearFrom)
        if (currentYearTo) params.append('yearTo', currentYearTo)
        if (this.currentPage) params.append('page', this.currentPage)
        if (this.currentVendors.length) {
          params.append('vendors', this.currentVendors.join(','))
        } else {
          params.append('vendors', '')
        }

        Object.entries(options).forEach(([key, val]) => params.append(key, val))

        return `${baseUrl}?${params.toString()}`
      }

      async getMotoData() {
        try {
          const res = await fetch(
            this.buildMotoDataUrl('https://searchapp.pneusplanet.it/p_api/moto-data'),
          )
          const data = await res.json()
          data['brands'] &&
            (this.motoData.brands = data['brands'].filter(Boolean))
          data['models'] &&
            (this.motoData.models = data['models'].filter(Boolean))
          data['years_from'] &&
            (this.motoData.yearsFrom = data['years_from'].filter(
              (val) => !!Number(val),
            ))
          data['years_to'] &&
            (this.motoData.yearsTo = data['years_to'].filter(
              (val) => !!Number(val),
            ))
        } catch (err) {
          console.error('FETCHING BRANDS ERROR: ', err)
          this.motoData = {}
        }
      }

      fillDropdownWithOptions(el, key, currentValue = '') {
        let label = 'Marca' 
        if(key === 'models') {
          label = 'Modello' 
        }
        if(key === 'yearsTo') {
          label = 'Fine produzione' 
        }
        if(key === 'yearsFrom') {
          label = 'Inizio produzione' 
        }
        el.innerHTML = [
          ['', label],
          ...(this.motoData[key] ?? []).map((val) => [val, val]),
        ]
          ?.map(
            ([value, label]) => `<option value="${value}">${label}</option>`,
          )
          .join('')

        !!currentValue && (el.value = currentValue)
      }

      async onDrodownChangeListener(e) {
        const { filterName } = e.target.dataset
        const value = e.target.value

        if (filterName === 'brand') {
          this.currentBrand = value
          this.currentModel = null
          this.currentYearFrom = null
          this.currentYearTo = null
          this.motoData['models'] = []
          this.motoData['yearsFrom'] = []
          this.motoData['yearsTo'] = []
          await this.setCurrentMotoData()
          this.fillDropdownWithOptions(this.modelsDropdown, 'models')
          this.fillDropdownWithOptions(this.yearFromDropdown, 'yearsFrom')
          this.fillDropdownWithOptions(this.yearToDropdown, 'yearsTo')
        }

        if (filterName === 'model') {
          this.currentModel = value
          this.currentYearFrom = null
          this.currentYearTo = null
          this.motoData['yearsFrom'] = []
          this.motoData['yearsTo'] = []
          await this.setCurrentMotoData()
          this.fillDropdownWithOptions(this.yearFromDropdown, 'yearsFrom')
          this.fillDropdownWithOptions(this.yearToDropdown, 'yearsTo')
        }

        if (filterName === 'yearFrom') {
          this.currentYearFrom = value
          this.currentYearTo = null
          this.motoData['yearsTo'] = []
          await this.setCurrentMotoData()
          this.fillDropdownWithOptions(this.yearToDropdown, 'yearsTo')
        }

        if (filterName === 'yearTo') {
          this.currentYearTo = value
          await this.setCurrentMotoData()
        }

        this.submitBtn.disabled = !this.currentModel
      }

      async getProducts() {
        this.closest('section').classList.add('loading')
        try {
          const res = await fetch(
            this.buildProductsUrl('https://searchapp.pneusplanet.it/p_api/get-products', {
              limit: this.perPageLimit,
            }),
          )
          const resData = await res.json()

          const { data: pairs_of_products, totalPages, matches = {} } = resData
          this.matches = matches

          if (totalPages <= 0) {
            this.notFoundEl.style.display = 'block'
          } else {
            this.notFoundEl.style.display = 'none'
          }

          this.vendorOptionsListEl.innerHTML = Object.keys(this.brandsWithLogos)
            .filter(Boolean)
            .map((vendor) => this.getBrandItemTemplate(vendor))
            .join('')

          this.vendorListWrapper.style.display = 'flex'
          this.drawerTriggerBtn.style.display = 'inline-flex'

          document
            .querySelector('[data-vendor-options-list]')
            ?.querySelectorAll('input[type="checkbox"]:not(:disabled)')
            .forEach((checkbox) => {
              checkbox.addEventListener(
                'change',
                this.onCheckboxChange.bind(this),
              )
            })

          this.resultsContainer.innerHTML = pairs_of_products
            .map((pair, index) => this.getProductPairTemplate(pair, index))
            .join('')

          this.resultsContainer
            .querySelectorAll('[data-tire-type]')
            .forEach((tab) =>
              tab.addEventListener('click', (e) => {
                const value = e.target.dataset.tireType
                const parentEl = e.target.closest(
                  '[data-filter-by-model-pair-item]',
                )
                parentEl.setAttribute('selected-tire-type', value)
              }),
            )

          this.resultsContainer
            .querySelectorAll('[filter-by-model-buy-btn]')
            .forEach((btn) =>
              btn.addEventListener('click', this.addToCardHandler.bind(this)),
            )

          this.updatePagination(totalPages)
          document
            .querySelectorAll('[data-filter-by-model-page]')
            .forEach((page) => {
              page.addEventListener('click', this.onPaginationChange.bind(this))
            })
          this.resultsContainer.scrollIntoView({ behavior: 'smooth' })
        } catch (err) {
          console.log('GET PRODUCTS ERROR: ', err)
        } finally {
          this.closest('section').classList.remove('loading')
        }
      }

      onPaginationChange(e) {
        const page = e.target.textContent
        this.currentPage = page

        const currentURL = new URL(window.location.href)
        currentURL.searchParams.set('page', this.currentPage)
        window.history.replaceState({}, '', currentURL.toString())
        this.getProducts()
      }

      onCheckboxChange(e) {
        const isChecked = e.target.checked
        const vendorName = e.target.name

        if (!window.matchMedia('(min-width: 990px)').matches) return

        if (isChecked) {
          !this.currentVendors.includes(vendorName) &&
            this.currentVendors.push(vendorName)
        } else {
          this.currentVendors = this.currentVendors.filter(
            (vendor) => vendor !== vendorName,
          )
        }

        this.currentPage = 1
        const currentURL = new URL(window.location.href)
        currentURL.searchParams.set('vendors', this.currentVendors.join(','))
        currentURL.searchParams.set('page', this.currentPage)
        window.history.replaceState({}, '', currentURL.toString())
        this.getProducts()
      }

      onVendorsDismissBtn() {
        this.currentVendors = []
        this.currentPage = 1

        const currentURL = new URL(window.location.href)
        currentURL.searchParams.set('vendors', this.currentVendors.join(','))
        currentURL.searchParams.set('page', this.currentPage)
        window.history.replaceState({}, '', currentURL.toString())
        this.getProducts()
        document.body.classList.remove(
          'page-layout-sidebar-drawer-open',
          'overflow-hidden-tablet',
        )
      }

      onVendorsFilterAddBtn() {
        this.currentVendors = Array.from(
          this.vendorOptionsListEl.querySelectorAll('input:checked'),
        ).map((input) => input.name)
        this.currentPage = 1
        const currentURL = new URL(window.location.href)
        currentURL.searchParams.set('vendors', this.currentVendors.join(','))
        currentURL.searchParams.set('page', this.currentPage)
        window.history.replaceState({}, '', currentURL.toString())
        this.getProducts()
      }

      async onSumbitListener() {
        const currentURL = new URL(window.location.href)
        const params = currentURL.searchParams

        currentURL.searchParams.delete('brand')
        currentURL.searchParams.delete('model')
        currentURL.searchParams.delete('yearFrom')
        currentURL.searchParams.delete('yearTo')
        currentURL.searchParams.delete('vendors')

        this.currentVendors = []

        if (!!this.currentBrand) params.set('brand', this.currentBrand)
        if (!!this.currentModel) params.set('model', this.currentModel)
        if (!!this.currentYearFrom) params.set('yearFrom', this.currentYearFrom)
        if (!!this.currentYearTo) params.set('yearTo', this.currentYearTo)
        params.set('page', 1)

        currentURL.search = params.toString()

        // Update browser URL without reload
        window.history.replaceState({}, '', currentURL.toString())

        // Update current page in code and fetch results
        this.currentPage = 1
        await this.getProducts()

        // window.location.href = currentURL.toString()
      }

      updatePagination(m) {
        var current = Number(this.currentPage) || 1,
          last = m,
          delta = 2,
          left = current - delta,
          right = current + delta + 1,
          range = [],
          rangeWithDots = [],
          l

        for (let i = 1; i <= last; i++) {
          if (i == 1 || i == last || (i >= left && i < right)) {
            range.push(i)
          }
        }


        for (let i of range) {
          if (l) {
            if (i - l === 2) {
              rangeWithDots.push(l + 1)
            } else if (i - l !== 1) {
              rangeWithDots.push('...')
            }
          }
          rangeWithDots.push(i)
          l = i
        }

        this.pagination.innerHTML = rangeWithDots
          .map((item) =>
            item === '...'
              ? `<span>${item}</span>`
              : `<span data-filter-by-model-page class="page-number ${
                  this.currentPage == item ? 'page-number-active' : ''
                }">${item}</span>`,
          )
          .join('')
      }

      getProductPairTemplate(pair, index) {
        const { ean_vo_product: frontTire, ean_hi_product: rearTire } = pair
        const amount =
          (Number(frontTire.priceRange.minVariantPrice.amount) +
            Number(rearTire.priceRange.minVariantPrice.amount)) /
          100
        const discount = this.discountPercent > 0 ? this.discountPercent : 0
        const discountedPrice = discount > 0 ? amount * (1 - discount / 100) : null

        const stikeThroughAmount = discount > 0 ? `€${amount.toFixed(2)} EUR` : ''
        const sumAmount = `€${(discount > 0 ? discountedPrice : amount).toFixed(2)} EUR`

        const frontVariantId = frontTire.selectedVariantId.replace(
          'gid://shopify/ProductVariant/',
          '',
        )
        const rearVariantId = rearTire.selectedVariantId.replace(
          'gid://shopify/ProductVariant/',
          '',
        )
        return `
        <div class="filter-by-model-pair-item" data-filter-by-model-pair-item selected-tire-type="anteriore" data-front-tire-variant-id="${frontVariantId}" data-rear-tire-variant-id="${rearVariantId}">
          ${this.getProductTabsTemplate(index)}
          <div class="filter-by-model-pair">
          ${[frontTire, rearTire]
            .map((tire, index) => this.getProductTemplate(tire, index === 0))
            .join('')}
          </div>
          <div class="filter-by-model-price typography-body">
            <span class="filter-by-model-price-title card-heading">prezzo coppia</span>
            <span class="filter-by-model-price-value-container price-item"><span class="card-heading filter-by-model-price-value">${sumAmount}</span> <span class="card-heading filter-by-model-price-compared-value">${stikeThroughAmount}</span> ${
          this.priceSuffix ? `<span class="sup">${this.priceSuffix}</span>` : ''
        }</span>
          </div>
          <div class="filter-by-model-buy-btn-wrapper">
            <button class="filter-by-model-buy-btn" filter-by-model-buy-btn><span>Acquista la coppia</span> ${cartSVG}</button>
          </div>
        </div>
        `
      }

      getProductTemplate(product, isFront = false) {
        return `
        <div class="filter-by-model-item">
          <div class="filter-by-model-item-content">
            <figure class="filter-by-model-item-media">
                <a href="/products/${
                  product.handle
                }" target="_blank" class="js-product-link">
                  <img src="${product?.featuredImage?.url ?? ''}" alt="${
          product?.featuredImage?.altText ?? ''
        }" width="950" height="950" class="filter-by-model-item-image">
                </a>
            </figure>
            <div class="filter-by-model-item-info">
                <div class="filter-by-model-item-vendor">
                  ${
                    this.brandsWithLogos[product.vendor]
                      ? `<img src="${
                          this.brandsWithLogos[product.vendor]
                        }" alt="${
                          product.vendor
                        }" class="filter-by-model-item-vendor-img">`
                      : ''
                  }
                </div>
                <span class="filter-by-model-item-type">${
                  isFront ? 'anteriore' : 'posteriore'
                }</span>
                <h3 class="card-heading typography-body">
                    <a href="/products/${product.handle}" target="_blank">${
          product.title
        }</a>
                </h3>
                <div class="price-regular">
                    <span class="price-item price-item-regular">
                    €${(
                      product.priceRange.minVariantPrice.amount / 100
                    ).toFixed(2)} EUR	${
          this.priceSuffix ? `<span class="sup">${this.priceSuffix}</span>` : ''
        }
                    </span>
                </div>
            </div>
          </div>
        </div>`
      }

      getProductTabsTemplate(index) {
        return `
          <div class="filter-by-model-tabs">
            <div class="filter-by-model-tab" style="" data-tire-type="anteriore">
              anteriore
            </div>
            <div class="filter-by-model-tab" style="" data-tire-type="posteriore">
              posteriore
            </div>
          </div>
        `
      }

      async addToCardHandler(e) {
        const parentEl = e.target.closest('[data-filter-by-model-pair-item]')

        const itemsToAdd = [
          {
            id: parentEl.dataset.frontTireVariantId, // Variant ID 1
            quantity: 1,
          },
          {
            id: parentEl.dataset.rearTireVariantId, // Variant ID 2
            quantity: 1,
          },
        ]

        this.closest('section').classList.add('loading')

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: itemsToAdd }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('Added to cart:', data)
            // Optionally redirect or update UI
            window.location.href = '/cart'
          })
          .catch((error) => {
            console.error('Error adding to cart:', error)
          })
          .finally(() => {
            this.closest('section').classList.remove('loading')
          })
      }

      getBrandItemTemplate(vendor) {
        const matchesCount = this.matches?.[vendor] ?? 0
        const isSelected = this.currentVendors.includes(vendor)
        return `                                                    
          <span class="checkbox-facet ${
            matchesCount <= 0 ? 'checkbox-facet-disabled' : ''
          }">
            <label for="${vendor}" class="checkbox-facet-label">
              <input type="checkbox" id="${vendor}" name="${vendor}" value="${vendor}" ${
          isSelected ? 'checked' : ''
        } form="FacetsFilterForm" ${matchesCount <= 0 ? 'disabled=""' : ''}>
              <span class="checkbox-facet-check"></span>
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
              </svg>
              <span class="checkbox-facet-label-text">${vendor}</span>
              <span class="checkbox-facet-label-count">${matchesCount}</span>
            </label>
          </span>`
      }
    },
  )
}
